import styled, {keyframes} from 'styled-components';

import {breakpoint} from '@app/styles/theme';

export const Root = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20;
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Paranja = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    animation: ${opacity} 0.2s ease;
`;

const slide = keyframes`
  from {
    transform: translate(100%);
  }

  to {
    transform: translate(0);
  }
`;

export const Sidebar = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 85%;
    max-width: 560px;
    padding: 30px 10px 40px;
    background-color: #fff;
    animation: ${slide} 0.2s ease;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);

    @media (max-width: ${breakpoint.tablet}) {
        padding-left: 20px;
        padding-right: 20px;
        max-width: 200px;
    }
`;

export const SidebarScrollable = styled.div`
    height: 100%;
    padding: 4px;
    overflow-y: auto;
`;

export const Title = styled.h3`
    margin-top: 0;
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 16px;
    text-transform: uppercase;
`;
